import axiosIns from "@/api/axios";

export const GET_ALL_DATA = (args) => {
  return axiosIns.get(`/type-contract?${args}`);
};

export const ADD_DATA = (args) => {
  return axiosIns.post("/type-contract", args);
};

export const UPDATE_DATA = (args) => {
  return axiosIns.put(`/type-contract/${args.id}`, args.data);
};

export const DELETE_DATA = (id) => {
  return axiosIns.delete(`/type-contract/${id}`);
};
